import styles from './Pagination.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import QualifiedLink from 'QualifiedLink/QualifiedLink';

function mapStateToProps({ search, location, results }) {
  const { paginationParameters } = results;

  return {
    query: search.query,
    linkState: { paginationParameters },
    currentPageNumber: location.pageNumber,
    pagination: results.pagination
  };
}

@connect(mapStateToProps)
class Pagination extends Component {

  static propTypes = {
    query: PropTypes.object.isRequired,
    linkState: PropTypes.object,
    currentPageNumber: PropTypes.number,
    pagination: PropTypes.object
  };

  render() {
    const { pagination, linkState } = this.props;

    if (pagination === null) {
      return null;
    }

    const { query, currentPageNumber } = this.props;
    const { showFirst, showPrev, pages, showNext } = pagination;
    const rootClassName = classnames({
      [styles.root]: true,
      [styles.showFirst]: showFirst
    });

    const commonLinkProps = {
      state: linkState
    };

    return (
      <p className={rootClassName}>
        {
          currentPageNumber > 1 &&
            <QualifiedLink
              {...commonLinkProps}
              className={styles.first}
              path="/jobs"
              rel="first"
              params={{ ...query, ...{ page: 1 } }}
              data-automation="page-first"
              scrollToTop={true}>
              First
            </QualifiedLink>
        }
        {
          showPrev &&
            <QualifiedLink
              {...commonLinkProps}
              className={styles.previous}
              path="/jobs"
              rel="prev"
              params={{ ...query, ...{ page: currentPageNumber - 1 } }}
              data-automation="page-prev"
              scrollToTop={true}>
              Prev
            </QualifiedLink>
        }
        {
          pages.map(page => currentPageNumber === page ?
            <span
              className={`${styles.page} ${styles.page_isActive}`}
              key={page}>
              {page}
            </span> :
            <QualifiedLink
              {...commonLinkProps}
              className={styles.page}
              path="/jobs"
              params={{ ...query, ...{ page } }}
              scrollToTop={true}
              data-automation={`page-${page}`}
              key={page}>
              {page}
            </QualifiedLink>
          )
        }
        {
          showNext &&
            <QualifiedLink
              {...commonLinkProps}
              className={styles.next}
              path="/jobs"
              rel="next"
              params={{ ...query, ...{ page: currentPageNumber + 1 } }}
              data-automation="page-next"
              scrollToTop={true}>
              Next
            </QualifiedLink>
        }
      </p>
    );
  }

}

export default Pagination;



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/Pagination/Pagination.js
 **/